module.exports = __webpack_public_path__ + "static/img/banner01.416966e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/banner01.jpg
// module id = H9NW
// module chunks = 0